import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/homeMock';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open ? 'bg-background-50/95 shadow-[0_6px_30px_-18px_rgba(0,0,0,0.25)]' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3.5">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-lg" />
          </span>
          <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
            吃瓜<span className="text-primary-500">最快</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition hover:bg-primary-50 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <span className="hidden items-center gap-2 rounded-full bg-primary-50 px-3 py-1.5 text-xs font-semibold text-primary-600 md:inline-flex">
            <span className="live-dot inline-block h-2 w-2 rounded-full bg-primary-500" />
            实时更新中
          </span>
          <a
            href="#breaking"
            className="hidden whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-foreground-700 sm:inline-block"
          >
            去看首发
          </a>
          <button
            type="button"
            aria-label="切换导航菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 transition hover:bg-background-100 lg:hidden"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 px-4 pb-4 pt-2 lg:hidden">
          <div className="grid gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 transition hover:bg-primary-50 hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}